/**
 * Dealer Filter Alpine.js Component
 */

window.dealerFilterData = function() {
  return {
    // Data
    regions: [],
    countries: [],
    dealers: [],
    selectedRegion: '',
    selectedCountry: '',
    loading: true,
    error: '',

    // Base URL for API calls (without filter segments)
    get baseUrl() {
      let path = window.location.pathname.replace(/\/$/, '');
      const filterIndex = path.indexOf('/filter/');
      if (filterIndex !== -1) {
        path = path.substring(0, filterIndex);
      }
      return path;
    },

    get selectedRegionData() {
      if (!this.selectedRegion) return null;
      return this.regions.find(r => r.URLSegment === this.selectedRegion) || null;
    },

    get selectedCountryData() {
      if (!this.selectedCountry) return null;
      return this.countries.find(c => c.URLSegment === this.selectedCountry) || null;
    },

    async init() {

      try {
        await this.loadRegions();

        await this.parseURLState();
      } catch (error) {
        console.error('Init error:', error);
        this.error = 'Failed to initialize dealer filter';
      }
    },

    async loadRegions() {
      try {
        const response = await fetch(`${this.baseUrl}/regions`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Failed to load regions');

        const data = await response.json();
        this.regions = data.regions || [];
      } catch (error) {
        console.error('Error loading regions:', error);
        this.error = 'Failed to load regions';
        throw error;
      }
    },

    async loadCountries(region = 'all') {
      this.loading = true;
      this.error = '';

      try {
        const response = await fetch(`${this.baseUrl}/countries/${region}`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Failed to load countries');

        const data = await response.json();
        this.countries = data.countries || [];
      } catch (error) {
        console.error('Error loading countries:', error);
        this.error = 'Failed to load countries';
        this.countries = [];
      } finally {
        this.loading = false;
      }
    },

    async loadDealers(region = 'all', country = 'all') {
      this.loading = true;
      this.error = '';

      try {
        const response = await fetch(`${this.baseUrl}/filter/${region}/${country}`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.error || 'Failed to load dealers');
        }

        const data = await response.json();
        this.dealers = data.dealers || [];
      } catch (error) {
        console.error('Error loading dealers:', error);
        this.error = error.message || 'Failed to load dealers';
        this.dealers = [];
      } finally {
        this.loading = false;
      }
    },

    resetFilters() {
      this.selectedRegion = '';
      this.selectedCountry = '';
      this.loadCountries('all');
      this.loadDealers('all', 'all');
      this.updateURL();
    },

    async onRegionChange() {

      // Reset country selection
      this.selectedCountry = '';

      const region = this.selectedRegion || 'all';
      await this.loadCountries(region);

      // Load dealers for new region (all countries)
      await this.loadDealers(region, 'all');

      this.updateURL();
    },

    async onCountryChange() {

      const region = this.selectedRegion || 'all';
      const country = this.selectedCountry || 'all';
      await this.loadDealers(region, country);

      this.updateURL();
    },

    updateURL() {
      const region = this.selectedRegion || 'all';
      const country = this.selectedCountry || 'all';
      const newUrl = `${this.baseUrl}/filter/${region}/${country}`;

      // Only update if different from current URL
      if (window.location.pathname !== newUrl) {
        window.history.replaceState({}, '', newUrl);
      }
    },

    async parseURLState() {
      const path = window.location.pathname;
      const parts = path.split('/').filter(p => p);

      // Check if URL contains filter segments
      const filterIndex = parts.indexOf('filter');
      if (filterIndex !== -1 && parts.length > filterIndex + 2) {
        const region = parts[filterIndex + 1];
        const country = parts[filterIndex + 2];

        // Set region selection first (regions are already loaded)
        this.selectedRegion = region !== 'all' ? region : '';

        await this.loadCountries(region);

        // Set country selection AFTER countries are loaded
        this.selectedCountry = country !== 'all' ? country : '';

        await this.loadDealers(region, country);
      } else {
        // No filters in URL, load all countries and dealers
        await this.loadCountries('all');
        await this.loadDealers('all', 'all');
      }
    }
  };
};
